import React from 'react'
import ReportModal from '../../../components/Report/ReportModal'
import { useDispatch, useSelector } from "react-redux";
import * as userAuthActions from "../../../redux/actions/userAuthAction";
import { bindActionCreators } from "redux";
import { PREFERED_LANGUAGE_KEYS } from '../../../App.config';
/**
* @author
* @function ReportModalContainer
**/

const ReportModalContainer = (props) => {
    const userAuthReducer = useSelector((state) => state.userAuthReducer);
    const i18nReducer = useSelector((state) => state.i18nState);
    const dispatch = useDispatch();

    const userAuthAction = bindActionCreators(userAuthActions, dispatch);

    const getAllReports = (moduleId) => {
        const isLangEng = i18nReducer.lang == PREFERED_LANGUAGE_KEYS.EnglishUS
        userAuthAction.getReports(props.selectedCompany,moduleId,isLangEng);
    }

    const getReportModule = () => {
        const isLangEng = i18nReducer.lang == PREFERED_LANGUAGE_KEYS.EnglishUS
        userAuthAction.getReportModule(props.selectedCompany,isLangEng);
    }

    const onAccessSaveSuccess = () => {
        props.closeRemoveModal();
    }

    const handleSubmit = (data) => {
        data.selectedCompany = props.selectedCompany;
        userAuthAction.SaveReportAccess(data, onAccessSaveSuccess);
        //props.GetReportsByCompany(props.selectedCompany);
    }

    const getAllCompanyList = () => {
        userAuthAction.getAllCompanyList();
    }

    const resetAllReport = () => {
        userAuthAction.resetAllReport();
    }

    return (
        <ReportModal 
            handleSubmit={handleSubmit} 
            userAuthReducer={userAuthReducer} 
            getAllCompanyList={getAllCompanyList} 
            getAllReports={getAllReports}
            getReportModule={getReportModule}
            resetAllReport={resetAllReport}
            i18nReducerLang={i18nReducer.lang}
        />
    )
}


export default ReportModalContainer